export default {
  TITLE: '国际配送条款与条件',
  CONTENT: `
    <p class="p-t-24">
      您订单中的每件商品都由 Amazon Export Sales,LLC.（简称“亚马逊美国”）或被指定销售商品的零售商（简称“零售商”）销售。
    </p>
    <p>
      请点击<a data-path="https://www.amazon.com/gp/help/customer/display.html?nodeId=14309551">此处</a>查阅美国亚马逊网站上本条款与条件原文。本页面中文内容仅供参考,请以英文原文内容为准。
    </p>
    <p>
      运送至美国境外国家/地区的商品可能需要缴纳由目的地国家/地区收取的税费、关税和费用（简称进口费）。目的地国家/地区的收货人为被记录的进口方，由其负责所有进口费用。
    </p>
    <p>
      对于已计算进口费用的每件商品，您授权亚马逊美国或零售商（视情况而定）指定承运商（简称指定承运商）作为您的代理人与目的地国家/地区的相关海关和税务机关交涉，为您的商品结关、处理并支付该商品的实际进口费。
    </p>
    <p>
      进口费用保证金为您订单中的商品运送至美国境外的国家所预估的进口费用。通过下订单，您同意允许亚马逊美国和/或零售商（视情况而定）对您订单中的适用商品收取进口费用保证金。该保证金将代表您本人用于偿付指定承运商代您向目的地国家/地区的有关当局支付的进口费用。
    </p>
    <p>
      您进一步同意，指定承运商可向亚马逊美国或零售商（视情况而定）披露对您从亚马逊美国或零售商处购买的商品所征收的实际进口费用的金额（简称实际进口费用）。如果进口费用保证金超出实际进口费用，亚马逊美国或零售商（视情况而定）将向您退还差额。
    </p>
    <p>
      对于代表另一收货人进行的订购，您也同意代表在订单中指定的收货人给予上述授权。
    </p>
    <p>
      如需获得有关实际进口费用的详细信息或与结关有关的单据或收据，您可以联系在您的发货确认电子邮件中指明的指定承运商。这些条款和条件作为亚马逊网站标准的使用条件的补充。根据这些使用条件，在商品交付至美国的公共承运商时，该商品的所有权和灭失风险即转移给收货人。
    </p>
    <p>
      请注意，参加国际直运计划的零售商可具有与亚马逊美国的条款和条件不同的政策。对于从零售商处购买的商品，请查看适用的零售商政策，了解可能适用于您购买的商品的任何其他条款和条件。
    </p>
    <h3>限制</h3>
    <p>
      对于跨国运送的商品，请注意任何制造商担保均可能失效；制造商提供的服务选择可能不再适用；产品手册、说明书和安全注意事项可能未使用目的地国家/地区的语言；产品（及随附材料）可能未根据目标国家/地区的标准、规格和包装要求进行设计；且产品可能不符合目的地国家/地区的电压和其他电气标准（如适当，需要使用适配器或转换器）。您负责确保产品可合法地进口至目的地国家/地区。从
      Amazon.com订购时，收件人是被记录的进口方，必须遵循目的地国家/地区的所有法律法规。
    </p>
    <h3>隐私</h3>
    <p>
      您的隐私对我们很重要，我们知道您关心有关您订单的信息的使用和共享方式。我们希望我们的国际客户和跨国运送商品的客户了解，跨境运送可能会被海关和/或邮政机关打开并检查。
    </p>
    <p>
      此外，我们可能会向国际承运商提供有关特定订单、装运货物和产品的信息（如产品名称），而承运商可能会将此类信息传达给海关和/或邮政当局以便为清关手续提供便利并确保遵循本地法律。
    </p>
    <p>
      如果您购买了礼品，包裹会被标示为礼品，但商品的价值将体现在报关文件里。
    </p>
    <p>海关当局要求将礼品价值直接标示在包裹上。</p>
  `
};
